import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { PackagesBaseDataProvider } from '../dataProvider/PackagesBaseDataProvider';

export class PackagesGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PackagesBaseDataProvider);
  }
}
